export const isFullStatic = false
export const staticPath = "/var/lib/jenkins/workspace/prodscb-pc-fe-ssr-ansible/.nuxt/static-json"
export const publicPath = "//v.shangchuanba.com/s/p/pcfe/"
export const globalContext = "__NUXT__"
export const globalNuxt = "$nuxt"